// extracted by css-extract-rspack-plugin
module.exports =  {"root":"TypingIndicator__root___jb7BA","typing":"TypingIndicator__typing___GLIsI","name":"TypingIndicator__name____RQ66"};